import type { QueryClient } from '@tanstack/react-query';
import { shouldRecoveryRefetchRealtimeQuery } from './fan-out.js';

/**
 * Recover cached realtime snapshots after a verified online edge. One
 * predicate refetch: TanStack keeps its disabled/static/pause handling, an
 * in-flight fetch is shared instead of cancelled, and per-query failures
 * follow each query's own retry policy (`refetchQueries` never rejects).
 */
export async function refetchRecoverySnapshots(queryClient: QueryClient): Promise<void> {
  const queries = queryClient.getQueryCache().findAll({
    predicate: (query) => shouldRecoveryRefetchRealtimeQuery(queryClient, query),
  });
  if (queries.length === 0) return;
  const selectedQueries = new Set(queries);
  await queryClient.refetchQueries(
    { predicate: (query) => selectedQueries.has(query), type: 'all' },
    { cancelRefetch: false },
  );
}
